import { FC } from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'

type PoiSearchProps = {
    search: (value: string) => void
    query: string
}

export const PoiSearch: FC<PoiSearchProps> = ({ search, query }) => {
    return (
        <div className={'relative'}>
            <Input
                type="search"
                id="search"
                placeholder="Suchen"
                value={query ?? ''}
                onChange={(e) => search(e.target.value)}
                className="h-8 pl-7 bg-mm-bg3"
            />
            <Search className="pointer-events-none absolute left-2 top-1/2 size-4 -translate-y-1/2 select-none opacity-50" />
        </div>
    )
}
